import { useNavigate, useParams } from 'react-router-dom';
import { mockInstitutions } from '../mockInstitutions';
import { DetailPageLayout } from '@/components/Layout/DetailPageLayout';
import { Badge, Button, Card, InfoItem } from '@/components/ui';
import { formatDateTime } from '@/utils/dateTime';

export default function InstitutionDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const institutionId = id ? Number(id) : NaN;
  const institution = mockInstitutions.find((item) => item.id === institutionId);

  return (
    <DetailPageLayout
      title="기관 상세"
      subtitle={institution ? `ID: ${institution.id} | ${institution.code}` : undefined}
      onBack={() => navigate('/dashboard/institutions')}
      isError={!institution}
      errorMessage="기관 정보를 찾을 수 없습니다."
      actions={
        <Button variant="outline" onClick={() => navigate(`/dashboard/institutions/${institutionId}/edit`)}>
          수정
        </Button>
      }>
      {institution && (
        <>
          <Card title="기본 정보">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              <InfoItem label="기관 ID" value={institution.id.toString()} />{' '}
              <InfoItem
                label="상태"
                value={
                  <Badge variant={institution.state === 'NORMAL' ? 'success' : 'danger'}>{institution.state}</Badge>
                }
              />
              <InfoItem label="기관명" value={institution.name} />
              <InfoItem label="기관 코드" value={institution.code} />
              <InfoItem label="생성일" value={formatDateTime(institution.createdAt)} />
              <InfoItem label="수정일" value={formatDateTime(institution.updatedAt)} />
            </div>
          </Card>

          <Card title="기관 이미지">
            {institution.imageUrl ? (
              <div className="flex items-center gap-6">
                <img
                  src={institution.imageUrl}
                  alt={`${institution.name} 로고`}
                  className="h-24 w-24 rounded-lg border border-slate-200 object-cover"
                />
                <InfoItem label="이미지 URL" value={institution.imageUrl} />
              </div>
            ) : (
              <p className="text-sm text-slate-500">등록된 이미지가 없습니다.</p>
            )}
          </Card>
        </>
      )}
    </DetailPageLayout>
  );
}
